<template>
    <div :class="namespaceClass()">
        <mds-section :size="8" :title="transactionSectionTitle" bold border="tertiary">
            <template v-slot:default>
                <div :class="namespaceClass('-portfolio-section-table')">
                    <portfolio-transaction
                        mwcId="settings-portfolio-transaction"
                        ref="portfolioTransaction"
                        @changeNotificationStatus="e => $emit('changeNotificationStatus', e)"
                    ></portfolio-transaction>
                </div>
            </template>
        </mds-section>
        <mds-section class="transactions-settings__section" :size="8" :title="getUILabel('liquidation_on_end_date')" bold border="tertiary">
            <template v-slot:default>
                <mds-checkbox size="small" e2e="liquidate-portfolio" v-model="liquidateOnEndDate">
                    {{ liquidateSectionTitle }}
                </mds-checkbox>
            </template>
        </mds-section>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import * as types from "../store/mutation-types.js";
import PortfolioTransaction from "./PortfolioTransaction.vue";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsSection from "@mds/section";
import MdsCheckbox from "@mds/checkbox";

export default {
    name: "transactions-content",
    components: {
        PortfolioTransaction,
        MdsSection,
        MdsCheckbox
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        hypoType() {
            return this.$store.getters["settings/getHypoType"];
        },
        transactionSectionTitle() {
            return this.hypoType === 2 ? this.getUILabel("portfolio_transaction_investment_title") : this.getUILabel("portfolio_transaction_title");
        },
        liquidateSectionTitle() {
            return this.hypoType === 2 ? this.getUILabel("liquidate_investment_on_end_date") : this.getUILabel("liquidate_portfolio_on_end_date");
        },
        liquidateOnEndDate: {
            get() {
                return this.$store.state.transaction.liquidateOnEndDate;
            },
            set(value) {
                this.$store.commit(`transaction/${types.SET_LIQUIDATE_ON_END_DATE}`, value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.transactions-settings__section {
    margin-top: $mds-space-4-x;
    margin-bottom: $mds-space-2-x;
}
</style>
